import { useState } from "react";

import { beautySimulatorSizes } from "./beauty.constants";
import { calculateBeautySimulator } from "./beauty.simulator";
import type { BeautySimulatorSize } from "./beauty.types";

export function useBeautySimulator() {
  const initialSize = beautySimulatorSizes[0];
  const [selectedSizeId, setSelectedSizeId] = useState(initialSize.id);
  const [appointments, setAppointments] = useState(initialSize.appointments);
  const [ticket, setTicket] = useState(initialSize.ticket);
  const [absenceRate, setAbsenceRate] = useState(initialSize.absenceRate);

  const selectedSize =
    beautySimulatorSizes.find((size) => size.id === selectedSizeId) ?? initialSize;
  const { missedAppointments, monthlyLoss, recoveredEstimate, annualLoss } = calculateBeautySimulator({
    appointments,
    ticket,
    absenceRate
  });

  const selectSimulatorSize = (size: BeautySimulatorSize) => {
    setSelectedSizeId(size.id);
    setAppointments(size.appointments);
    setTicket(size.ticket);
    setAbsenceRate(size.absenceRate);
  };

  return {
    sizes: beautySimulatorSizes,
    selectedSize,
    selectedSizeId,
    appointments,
    setAppointments,
    ticket,
    setTicket,
    absenceRate,
    setAbsenceRate,
    missedAppointments,
    monthlyLoss,
    recoveredEstimate,
    annualLoss,
    selectSimulatorSize
  };
}
